const manual = `<svg viewBox="0 0 11.8333333 14">
    <g stroke="currentColor" stroke-width="1" stroke-linejoin="bevel">
        <g transform="translate(0.5, 0.5)">
            <path d="M10.8333333,10.8333333 L10.8333333,3.25 L10.8235833,0 L0,0 L0,11.375 M0,11.375 C0,12.2724627 0.727537282,13 1.625,13 L10.8333333,13 L10.8333333,11.2125 L10.8235833,9.75 L1.625,9.75 C0.727537282,9.75 0,10.4775373 0,11.375 L0,11.375 Z M2.17208333,0 L2.17208333,4.33333333 L3.79708333,2.49708333 L5.42208333,4.33333333 L5.42208333,0 L2.17208333,0 L2.17208333,0 Z"></path>
        </g>
    </g>
</svg>`
export default manual